module.exports = __webpack_public_path__ + "img/expand_circle_down.5043c3b5.svg";